import { Component, ElementRef, Input, OnChanges, QueryList, ViewChildren, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GetArticlesService } from 'src/app/services/get-articles.service';
import { faqData } from 'src/interface/faq';

@Component({
  selector: 'app-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss']
})
export class FaqSectionComponent implements OnChanges, OnDestroy {
  @Input() journalid: string;
  faqArray: faqData[];
  limit = 5;
  showbutton: string;
  showbuttonstatus: boolean[] = [];
  hidebutton: boolean[] = [];
  nodelength: number;
  subscriptionArr: Subscription[] = [];

  @ViewChildren('showref', { read: ElementRef }) showref: QueryList<ElementRef>;
  loading = true;
  items = new Array(3).fill(0);
  constructor(private faqserivce: GetArticlesService) {
    this.showbutton = 'Show more';
    setTimeout(() => {
      this.loading = false;
    }, 1000);

  }



  ngOnChanges(): void {
    this.getFaqData(this.journalid);
    const objfaq = {
      journal_id: this.journalid
    }
    const subscription = this.faqserivce.getFaqData(objfaq).subscribe(result => {
      this.faqArray = result.data;
      for (let i = 0; i < this.faqArray.length; i++) {
        const node = this.showref.toArray()[i].nativeElement;
        this.nodelength = this.getOffsetLength(node);
        if (this.nodelength > 80.5) {
          this.hidebutton[i] = true;
        }

      }
    })
    this.subscriptionArr.push(subscription);
  }


  getFaqData(journal_id: string) {
    const objfaq = {
      journal_id: journal_id
    }
    const subscription = this.faqserivce.getFaqData(objfaq).subscribe(result => {
      this.faqArray = result.data;

    })
    this.subscriptionArr.push(subscription);


  }
  showmore(i: number) {
    this.showbuttonstatus[i] = !this.showbuttonstatus[i];
    const node = this.showref.toArray()[i].nativeElement
    this.nodelength = this.getOffsetLength(node);

    // if (this.nodelength > 109.5) {

    //   this.hidebutton = true;
    // }
    // else {
    //   this.hidebutton = false;
    // }



    if (this.showbuttonstatus[i] == false) {
      node?.classList.remove('showmoreclass');
    }
    if (this.showbuttonstatus[i] == true) {
      node?.classList.add('showmoreclass');
    }
  }
  private getOffsetLength(element: HTMLElement): number {
    const rect = element.getBoundingClientRect();
    return rect.height; // You can use rect.height for vertical offset
  }

  ngOnDestroy() {
    this.subscriptionArr.forEach(x => {
      if (!x.closed) {
        x.unsubscribe();
      }
    });
  }

}
